import { useContext } from 'react';

import ColorTokensContext from '../context/ColorTokensContext';

const useColorTokens = () => {
  const colorTokens = useContext(ColorTokensContext);

  return colorTokens;
};

export default useColorTokens;
